import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

import UsersList from "./UsersList.js"

import ErrorMessageDialog from "./../ui/ErrorMessageDialog"

import api from "./../api.js"

/**
 * title - заголовок диалога.
 * 
 * onSelectUser(user)
 * onCancel
 */

/** 
 * По факту фильтры не используются, буду считать их Deprecated
 * 
 * filter - массив строк с названиями прав доступа для отображения
 * ["admin", "artist", "worker"]
 * если filter не установлен, отображает всех
 */

class SelectUserDialog extends Component {

	constructor(props) {

		super(props)

		this.state = {
			dialog: undefined,
			selected: undefined,
			usersAmount: 0,
			users: [],
		}

		this.handle_onClickUser = this.handle_onClickUser.bind(this)
		this.handle_error = this.handle_error.bind(this)

	}

	permissionCodeToPermissionName(code) {
		switch (code) {
			case "2": return "admin"
			case "3": return "worker"
			case "4": return "artist"
			default: return "nobody"
		}
	}

	update = async () => await api.users.list().then(response => this.setState({users: response.users}))

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => this.setState({dialog: undefined}))
						.catch(this.handle_error)
				}}
			/>
		})
	}	

	componentDidMount() {
		this.update().catch(this.handle_error)
	}

	handle_onClickUser(user) {
		if (this.state.selected && this.state.selected.id === user.id) {
			// Если повторное нажатие.
			if (typeof this.props.onSelectUser === "function") {
				this.props.onSelectUser(user)
			}
		} else {
			// Если нажали в первый раз.
			this.setState({selected: user})
		}
	}

	render() {
		if (this.state.dialog) {
			return this.state.dialog
		}
		return <Dialog open scroll = "body" fullWidth = {true}>
			<DialogTitle>{this.props.title || "Выбрать пользователя"}</DialogTitle>
			<DialogContent>
				<UsersList
					widthFix
					users = {this.state.users}
					filter = {this.props.filter}
					selected = {this.state.selected}
					onUserClick = {this.handle_onClickUser}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					disabled = {!this.state.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSelectUser === "function") {
							this.props.onSelectUser(this.state.selected)
						}
					}}
				>Выбрать</Button>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>
			</DialogActions>
		</Dialog>
	}
}

export default SelectUserDialog
